import React, { useState } from "react";
import LogsPdfManager from "./LogsPdfManager"; // Assuming this component already exists
import LogsManagementTabs from "./LogsManagementTabs";

const LogsPdfManagerContainer = () => {
	const [showJobsHistory, setShowJobsHistory] = useState(false);

	// If showing jobs history, render the LogsManagementTabs component with onBack handler
	if (showJobsHistory) {
		return <LogsManagementTabs onBack={() => setShowJobsHistory(false)} />;
	}

	// Otherwise render the main LogsPdfManager with a callback to show history
	return <LogsPdfManager onShowJobsHistory={() => setShowJobsHistory(true)} />;
};

export default LogsPdfManagerContainer;
